import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-out-stock",
  "use": "icon-out-stock-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-out-stock\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm1 0c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10Zm-6.33-4.772a.779.779 0 1 1 1.102 1.101L11.102 10l3.67 3.67a.779.779 0 1 1-1.101 1.102L10 11.102l-3.67 3.67a.779.779 0 1 1-1.102-1.101L8.898 10l-3.67-3.67A.779.779 0 1 1 6.33 5.227L10 8.898l3.67-3.67Z\" fill=\"#ED1C24\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol